import { BASE_ROLE_QUERY } from "@app/shared/authentication/roles/queries/base-role.query";

/**
 * GraphQL selection for the vehicle block type dropdown.
 *
 * `minHours`, `maxHours`, and `futureBlock` are part of the selection because the
 * vehicle block form derives the start date lock and the expected end date window
 * from them. Roles are selected through the light `BASE_ROLE_QUERY` and users by id
 * only, because the form only matches them against the current user's role and id.
 */
export const VEHICLE_BLOCK_TYPE_DROPDOWN_QUERY = `
  id
  name
  isOneTimeUse
  minHours
  maxHours
  enabled
  futureBlock {
    allowed
    role { ${BASE_ROLE_QUERY} }
    users { id }
  }
`;
